module.exports = __webpack_public_path__ + "static/media/Grandma-Tutu-Blue.84b3d00f.png";